import { render, staticRenderFns } from "./CustomerService.vue?vue&type=template&id=ba45eb2e&scoped=true"
import script from "./CustomerService.vue?vue&type=script&lang=ts"
export * from "./CustomerService.vue?vue&type=script&lang=ts"
import style0 from "./CustomerService.vue?vue&type=style&index=0&id=ba45eb2e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba45eb2e",
  null
  
)

export default component.exports